import ImageBuddy from 'imagebuddy';
import { scrollTo, getViewportSizeName } from './general-util';
import ScrollStick from './scroll-stick';


class AutomationSidebarAnchor {
	constructor(blockEl) {
		this.blockEl = blockEl;
		this.sidebarEl = this.blockEl.querySelector('.automation-sidebar-container');


		this.blockAnimationWatcher = null;

		this.lastViewportSizeName = getViewportSizeName();

		this.initSticky();

		window.addEventListener('resize', () => {
			const viewportSizeName = getViewportSizeName();

			if (this.lastViewportSizeName !== viewportSizeName) {
				this.lastViewportSizeName = viewportSizeName;

				this.initSticky();
			}
		});


		this.extraRefreshTimeoutId = 0;

		// refresh the sticky sidebar whenever an image is successfully loaded
		ImageBuddy.on('image-loaded', (imgEl) => {
			if (imgEl.classList.contains('block-sidebar-anchor__image') && this.sidebarSticky) {
				this.sidebarSticky.refresh(true);

				if (this.extraRefreshTimeoutId) {
					clearTimeout(this.extraRefreshTimeoutId);
				}

				// add an extra refresh to ensure the full height of the parent
				// container is calculated correctly
				this.extraRefreshTimeoutId = setTimeout(() => {
					if (this.sidebarSticky) {
						this.sidebarSticky.refresh(true);
					}
				}, 500);
			}
		});
	}

	initSticky() {
		let topSpacing = 0;

		if (this.lastViewportSizeName === 'medium') {
			topSpacing = 80;
		} else if (this.lastViewportSizeName === 'large') {
			topSpacing = 100;
		}

		if (this.sidebarSticky) {
			this.sidebarSticky.setTopTriggerOffset(topSpacing);
		} else {
			this.sidebarSticky = new ScrollStick(this.sidebarEl, topSpacing);
		}
	}

	handleMobileMenuOpenClose = (e) => {
		e.preventDefault();

		if (this.blockEl.classList.contains('mobile-menu-open')) {
			this.blockEl.classList.remove('mobile-menu-open');
		} else {
			this.blockEl.classList.add('mobile-menu-open');
		}
	};

	handleSectionLinkClick = (e) => {
		e.preventDefault();
		this.blockEl.classList.remove('mobile-menu-open');

		const sectionId = e.currentTarget.getAttribute('href');
		const mobileSidebarButtonHeight = this.mobileMenuButtonEl.getBoundingClientRect().height;

		scrollTo(sectionId, mobileSidebarButtonHeight + 20);
	};

	handleSectionLinkToggleClick = (e) => {
		e.preventDefault();
		var index = e.currentTarget.dataset.linkIndex;
		var line = e.currentTarget.querySelector('.svg__plus--vertical-line');

		this.sectionLinkEls.forEach((linkEl) => {
			if ((linkEl.dataset.linkIndex === index) && linkEl.classList.contains('active')) {
				linkEl.classList.remove('active');
				line.style.display = 'block';
			}
			else if ((linkEl.dataset.linkIndex === index) && !linkEl.classList.contains('active') && linkEl.classList.contains('child')) {
				linkEl.classList.add('active');
				line.style.display = 'none';
			}
		});
		
	}
}

export default AutomationSidebarAnchor;
